export default __webpack_public_path__ + "static/CallUs-e8d2f2ec6fcc91498c3ef9f0cdaf5fa6.png";